module.exports = __webpack_public_path__ + "assets/img/jtsd.413a8954.png";